import { render, staticRenderFns } from "./InstallationAsApp.vue?vue&type=template&id=18bf0dc7"
import script from "./InstallationAsApp.vue?vue&type=script&lang=js"
export * from "./InstallationAsApp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports